/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_PasswordInputs */

const cs_share_password = /** @type {(inputs: Share_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo`)
};

const en_share_password = /** @type {(inputs: Share_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Share_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_password = /** @type {((inputs?: Share_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_password(inputs)
	return cs_share_password(inputs)
});